import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/shared/guards/auth.guard";
import { ReportAccessComponent } from "./components/report-access/report-access.component";
import { ReportInventoryComponent } from "./components/report-inventory/report-inventory.component";
import { ReportServiceRequestComponent } from "./components/report-service-request/report-service-request.component";
const ɵ0 = {
    breadcrumb: "Ordens de Serviço",
}, ɵ1 = {
    breadcrumb: "Ordens de Serviço",
}, ɵ2 = {
    breadcrumb: "Relatório de Acesso",
};
const routes = [
    {
        path: "report/service-request",
        component: ReportServiceRequestComponent,
        canActivate: [AuthGuard],
        data: ɵ0,
    },
    {
        path: "report/inventory",
        component: ReportInventoryComponent,
        canActivate: [AuthGuard],
        data: ɵ1,
    },
    {
        path: "report/access",
        component: ReportAccessComponent,
        canActivate: [AuthGuard],
        data: ɵ2,
    },
];
export class ReportRoutingModule {
}
export { ɵ0, ɵ1, ɵ2 };
